import { render, staticRenderFns } from "./salesStatistics.vue?vue&type=template&id=d6a436fa&scoped=true"
import script from "./salesStatistics.vue?vue&type=script&lang=js"
export * from "./salesStatistics.vue?vue&type=script&lang=js"
import style0 from "./salesStatistics.vue?vue&type=style&index=0&id=d6a436fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a436fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6a436fa')) {
      api.createRecord('d6a436fa', component.options)
    } else {
      api.reload('d6a436fa', component.options)
    }
    module.hot.accept("./salesStatistics.vue?vue&type=template&id=d6a436fa&scoped=true", function () {
      api.rerender('d6a436fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reportCenter/salesStatistics.vue"
export default component.exports